module.exports = __webpack_public_path__ + "static/media/Isaj.a6d32526.jpg";